import { Injectable } from '@angular/core';
import { IsbuilderService } from './isbuilder.service';
import { ComponentsService } from '@ic-builder/is-base';

@Injectable({
  providedIn: 'root',
})
export class IsgridsplitterService extends IsbuilderService {
  constructor(protected compservice: ComponentsService) {
    super(compservice);
  }

  addSplitters(target) {
    if (target.children.length > 1) {
      const splittergrid_id = 'splittergrid-' + target.attributes._isid.value;
      const id = target.attributes._isid.value;
      let splittergrid;

      if (!target.querySelector('#' + splittergrid_id)) {
        splittergrid = document.createElement('div');
        splittergrid.id = splittergrid_id;
        target.append(splittergrid);
      } else {
        splittergrid = document.querySelector('#' + splittergrid_id);
      }

      splittergrid.style.setProperty('display', 'grid');
      splittergrid.style.setProperty('position', 'absolute');
      splittergrid.style.setProperty('z-index', '999');
      splittergrid.style.setProperty('pointer-events', 'none');

      const rows = window.getComputedStyle(target).gridTemplateRows;
      const cols = window.getComputedStyle(target).gridTemplateColumns;
      const rowgap = window.getComputedStyle(target).gridRowGap;
      const colgap = window.getComputedStyle(target).gridColumnGap;

      const rowsMerged = this.mergeTemplateAndGap(rows, rowgap);
      const colsMerged = this.mergeTemplateAndGap(cols, colgap);

      splittergrid.style.setProperty('grid-template-rows', rowsMerged);
      splittergrid.style.setProperty('grid-template-columns', colsMerged);

      let splittersRow = [];
      let splittersCol = [];

      for (let i = 0; i < target.children.length; i++) {
        for (let j = 0; j < target.children.length; j++) {
          if (
            target.children[i].id.includes('splittergrid') ||
            target.children[j].id.includes('splittergrid')
          ) {
            // console.log(target.children[i])
            // console.log(target.children[j])
            break;
          }
          if (i != j) {
            const style1 = window.getComputedStyle(target.children[i]);
            const style2 = window.getComputedStyle(target.children[j]);

            const style1RowStart = Number(style1.gridRowStart);
            const style1RowEnd = Number(style1.gridRowEnd);
            const style1ColumnStart = Number(style1.gridColumnStart);
            const style1ColumnEnd = Number(style1.gridColumnEnd);
            const style2RowStart = Number(style2.gridRowStart);
            const style2RowEnd = Number(style2.gridRowEnd);
            const style2ColumnStart = Number(style2.gridColumnStart);
            const style2ColumnEnd = Number(style2.gridColumnEnd);

            // column style1 > style2
            if (
              style1RowStart <= style2RowStart &&
              style1RowEnd >= style2RowEnd
            ) {
              if (style1ColumnEnd == style2ColumnStart) {
                // splitter style 1 | style 2
                const rowstart = String(Number(style2.gridRowStart) * 2 - 1);
                const rowend = String(Number(style2.gridRowEnd) * 2 - 2);
                const colstart = String(Number(style1.gridColumnEnd) * 2 - 2);
                const colend = String(Number(style1.gridColumnEnd) * 2 - 1);
                const splitter = {
                  rowstart: rowstart,
                  rowend: rowend,
                  colstart: colstart,
                  colend: colend,
                };
                splittersCol.push(splitter);
              } else if (style1ColumnStart == style2ColumnEnd) {
                // splitter style2 | style1
                const rowstart = String(Number(style2.gridRowStart) * 2 - 1);
                const rowend = String(Number(style2.gridRowEnd) * 2 - 2);
                const colstart = String(Number(style2.gridColumnEnd) * 2 - 2);
                const colend = String(Number(style2.gridColumnEnd) * 2 - 1);
                const splitter = {
                  rowstart: rowstart,
                  rowend: rowend,
                  colstart: colstart,
                  colend: colend,
                };
                splittersCol.push(splitter);
              }
            }

            // column style1 < style2
            if (
              style1RowStart >= style2RowStart &&
              style1RowEnd <= style2RowEnd
            ) {
              if (style1ColumnEnd == style2ColumnStart) {
                // splitter style1 | style2
              } else if (style1ColumnStart == style2ColumnEnd) {
                // splitter style2 | style1
              }
            }

            // row style1 > style2
            if (
              style1ColumnStart <= style2ColumnStart &&
              style1ColumnEnd >= style2ColumnEnd
            ) {
              if (style1RowEnd == style2RowStart) {
                // splitter
                // style1
                // ------
                // style2
                const rowstart = String(Number(style1.gridRowEnd) * 2 - 2);
                const rowend = String(Number(style1.gridRowEnd) * 2 - 1);
                const colstart = String(Number(style2.gridColumnStart) * 2 - 1);
                const colend = String(Number(style2.gridColumnEnd) * 2 - 2);
                const splitter = {
                  rowstart: rowstart,
                  rowend: rowend,
                  colstart: colstart,
                  colend: colend,
                };
                splittersRow.push(splitter);
              } else if (style1RowStart == style2RowEnd) {
                // splitter
                // style2
                // ------
                // style1
                const rowstart = String(Number(style2.gridRowEnd) * 2 - 2);
                const rowend = String(Number(style2.gridRowEnd) * 2 - 1);
                const colstart = String(Number(style2.gridColumnStart) * 2 - 1);
                const colend = String(Number(style2.gridColumnEnd) * 2 - 2);
                const splitter = {
                  rowstart: rowstart,
                  rowend: rowend,
                  colstart: colstart,
                  colend: colend,
                };
                splittersRow.push(splitter);
              }
            }
          }
        }
      }

      // while (splittergrid.firstChild) {
      // splittergrid.removeChild(splittergrid.firstChild);
      // }

      // merge
      splittersCol.forEach((splitter1) => {
        splittersCol.forEach((splitter2) => {
          if (
            splitter1 != splitter2 &&
            splitter1.colstart == splitter2.colstart
          ) {
            const rowStart = Math.min(
              Number(splitter1.rowstart),
              Number(splitter2.rowstart)
            );
            const rowEnd = Math.max(
              Number(splitter1.rowend),
              Number(splitter2.rowend)
            );
            const col = Number(splitter1.colstart);

            let mergeable = true;

            for (let i = 0; i < target.children.length; i++) {
              const child = target.children[i];
              const style = window.getComputedStyle(child);
              const styleRowStart = Number(style.gridRowStart) * 2 - 1;
              const styleRowEnd = Number(style.gridRowEnd) * 2 - 2;
              const styleColStart = Number(style.gridColumnStart) * 2 - 2;
              const styleColEnd = Number(style.gridColumnEnd) * 2 - 3;

              if (styleColStart < col && styleColEnd > col) {
                if (
                  (styleRowStart > rowStart && styleRowStart < rowEnd) ||
                  (styleRowEnd < rowEnd && styleRowEnd > rowStart)
                ) {
                  mergeable = false;
                }
              }
            }
            if (mergeable) {
              const splitter = {
                rowstart: rowStart,
                rowend: rowEnd,
                colstart: splitter1.colstart,
                colend: splitter1.colend,
              };

              splittersCol = splittersCol.filter(
                (splitter) => splitter !== splitter1 && splitter !== splitter2
              );
              splittersCol.push(splitter);
            }
          }
        });
      });

      splittersRow.forEach((splitter1) => {
        splittersRow.forEach((splitter2) => {
          if (
            splitter1 != splitter2 &&
            splitter1.rowstart == splitter2.rowstart
          ) {
            const colStart = Math.min(
              Number(splitter1.colstart),
              Number(splitter2.colstart)
            );
            const colEnd = Math.max(
              Number(splitter1.colend),
              Number(splitter2.colend)
            );
            const row = Number(splitter1.rowstart);

            let mergeable = true;

            for (let i = 0; i < target.children.length; i++) {
              const child = target.children[i];
              const style = window.getComputedStyle(child);
              const styleRowStart = Number(style.gridRowStart) * 2 - 2;
              const styleRowEnd = Number(style.gridRowEnd) * 2 - 3;
              const styleColStart = Number(style.gridColumnStart) * 2 - 1;
              const styleColEnd = Number(style.gridColumnEnd) * 2 - 2;

              if (styleRowStart < row && styleRowEnd > row) {
                if (
                  (styleColStart > colStart && styleColStart < colEnd) ||
                  (styleColEnd < colEnd && styleColEnd > colStart)
                ) {
                  mergeable = false;
                }
              }
            }
            if (mergeable) {
              const splitter = {
                rowstart: splitter1.rowstart,
                rowend: splitter1.rowend,
                colstart: colStart,
                colend: colEnd,
              };

              splittersRow = splittersRow.filter(
                (splitter) => splitter != splitter1 && splitter != splitter2
              );
              splittersRow.push(splitter);
            }
          }
        });
      });

      // get min and max
      splittersCol.forEach((splitter) => {
        let min, max;
        for (let i = 0; i < target.children.length; i++) {
          const child = target.children[i];
          const style = window.getComputedStyle(child);
          const styleRowStart = Number(style.gridRowStart) * 2 - 1;
          const styleRowEnd = Number(style.gridRowEnd) * 2 - 2;
          const styleColStart = Number(style.gridColumnStart) * 2 - 1;
          const styleColEnd = Number(style.gridColumnEnd) * 2 - 2;

          if (
            styleRowStart >= Number(splitter.rowstart) &&
            styleRowEnd <= Number(splitter.rowend)
          ) {
            if (
              styleColEnd == Number(splitter.colstart) &&
              (min ? styleColStart > min : true)
            ) {
              min = styleColStart;
            }
            if (
              styleColStart == Number(splitter.colend) &&
              (max ? styleColEnd < max : true)
            ) {
              max = styleColEnd;
            }
          }
        }
        const split = { ...splitter, min: min, max: max };
        splittersCol.filter((s) => s != splitter);
        splittersCol.push(split);
      });

      splittersRow.forEach((splitter) => {
        let min, max;
        for (let i = 0; i < target.children.length; i++) {
          const child = target.children[i];
          const style = window.getComputedStyle(child);
          const styleRowStart = Number(style.gridRowStart) * 2 - 1;
          const styleRowEnd = Number(style.gridRowEnd) * 2 - 2;
          const styleColStart = Number(style.gridColumnStart) * 2 - 1;
          const styleColEnd = Number(style.gridColumnEnd) * 2 - 2;

          if (
            styleColStart >= Number(splitter.colstart) &&
            styleColEnd <= Number(splitter.colend)
          ) {
            if (
              styleRowEnd == Number(splitter.rowstart) &&
              (min ? styleRowStart > min : true)
            ) {
              min = styleRowStart;
            }
            if (
              styleRowStart == Number(splitter.rowend) &&
              (max ? styleRowEnd < max : true)
            ) {
              max = styleRowEnd;
            }
          }
        }
        const split = { ...splitter, min: min, max: max };
        splittersRow.filter((s) => s != splitter);
        splittersRow.push(split);
      });

      // add to html
      splittersCol.forEach((splitter) => {
        this.addSplitterToHTML(splitter, splittergrid, 'col', target);
      });

      splittersRow.forEach((splitter) => {
        this.addSplitterToHTML(splitter, splittergrid, 'row', target);
      });
    }
  }

  addSplitterToHTML(splitter, splittergrid, direction, target) {
    const id =
      'splitter-' +
      splitter.rowstart +
      '-' +
      splitter.rowend +
      '-' +
      splitter.colstart +
      '-' +
      splitter.colend +
      '-' +
      direction;
    let splitter_div;
    if (!splittergrid.querySelector('#' + id)) {
      splitter_div = document.createElement('div');
      splitter_div.id = id;
    } else {
      splitter_div = splittergrid.querySelector('#' + id);
    }

    splitter_div.style.setProperty('grid-row-start', splitter.rowstart);
    splitter_div.style.setProperty('grid-row-end', splitter.rowend);
    splitter_div.style.setProperty('grid-column-start', splitter.colstart);
    splitter_div.style.setProperty('grid-column-end', splitter.colend);
    splitter_div.style.setProperty('background-color', 'lightgray');
    splitter_div.style.setProperty('pointer-events', 'auto');
    splitter_div.style.setProperty(
      'cursor',
      direction == 'col' ? 'col-resize' : 'row-resize'
    );
    splitter_div.setAttribute('max-grid', splitter.max);
    splitter_div.setAttribute('min-grid', splitter.min);

    if (!splittergrid.querySelector('#' + id)) {
      splittergrid.append(splitter_div);
    }

    this.moveAble(splitter_div);
  }

  removeGrid(ob) {
    if (ob.attributes._isid) {
      const id = 'splittergrid-' + ob.attributes._isid.value;

      if (ob.querySelector('#' + id)) {
        ob.removeChild(ob.querySelector('#' + id));
      }
    }
  }

  mergeTemplateAndGap(template, gap) {
    const arr = [];
    const templates = template.split(' ');
    templates.forEach((temp) => {
      arr.push(temp);
      arr.push(gap);
    });
    arr.pop();
    return arr.join(' ');
  }

  moveAble(element) {
    // make action active
    let moveAble;

    let refX;
    let refY;

    let focused;

    const focusedHandler = {
      handleEvent: () => {
        focused = true;
      },
    };

    const blurHandler = {
      handleEvent: () => {
        focused = false;
      },
    };

    const mouseDownHandler = {
      handleEvent: (ev) => {
        const info = ev.currentTarget.getBoundingClientRect();
        moveAble = true;
        refX = ev.clientX - info.left;
        refY = ev.clientY - info.top;
      },
    };

    const mouseUpHandler = {
      handleEvent: () => {
        moveAble = false;
      },
    };

    const mouseMoveHandler = {
      handleEvent: (ev) => {
        if (moveAble) {
          ev.preventDefault();
          const compInfo = element.getBoundingClientRect();
          const childinfo = element.getBoundingClientRect();

          const corX = childinfo.left - compInfo.left;
          const corY = childinfo.top - compInfo.top;

          this.moveComponent2(element, ev, refX, refY, corX, corY);
        }
      },
    };

    element.addEventListener('focus', focusedHandler);

    element.addEventListener('blur', blurHandler);

    element.addEventListener('mousedown', mouseDownHandler);

    //make action inactive
    window.addEventListener('mouseup', mouseUpHandler);

    //execute action
    window.addEventListener('mousemove', mouseMoveHandler);

    this.activeEvents.push({
      eventname: 'focus',
      element: element,
      handler: focusedHandler,
    });
    this.activeEvents.push({
      eventname: 'blur',
      element: element,
      handler: blurHandler,
    });
    this.activeEvents.push({
      eventname: 'mousedown',
      element: element,
      handler: mouseDownHandler,
    });
    this.activeEvents.push({
      eventname: 'mouseup',
      element: window,
      handler: mouseUpHandler,
    });
    this.activeEvents.push({
      eventname: 'mousemove',
      element: window,
      handler: mouseMoveHandler,
    });
  }

  removeSplitters(ob) {
    const id = 'splittergrid-' + ob.attributes._isid.value;
    const splittergrid = ob.querySelector('#' + id);
    while (splittergrid ? splittergrid.firstChild : false) {
      splittergrid.removeChild(splittergrid.firstChild);
    }
  }

  moveComponent2(element, ev, refX, refY, corX, corY) {
    const parentinfo = element.parentElement.getBoundingClientRect();

    const style = window.getComputedStyle(element.parentElement);
    if (style.display == 'grid') {
      const rowHeightsSum = this.compservice.getRowHeightSum(
        this.compservice.scaleGrid(style, this.scalevalue)
      );
      const colWidthsSum = this.compservice.getColWidthSum(
        this.compservice.scaleGrid(style, this.scalevalue)
      );

      const elStyle = window.getComputedStyle(element);
      const colLength = this.compservice.getColLength(elStyle);
      const rowLength = this.compservice.getRowLength(elStyle);

      let startRow = this.compservice.getStartRow(
        ev,
        rowHeightsSum,
        parentinfo,
        refY - corY
      );
      let startCol = this.compservice.getStartCol(
        ev,
        colWidthsSum,
        parentinfo,
        refX - corX
      );

      if (element.id.includes('row')) {
        const min = Number(element.attributes['min-grid'].value);
        const max = Number(element.attributes['max-grid'].value);

        if (startRow <= min) startRow = min + 1;
        if (startRow + 1 > max) startRow = max - 1;

        const oldStartRow = element.style['grid-row-start'];

        startRow =
          Math.abs(startRow - element.style['grid-row-start']) % 2 == 0
            ? startRow
            : startRow - 1;
        element.style.setProperty('grid-row-start', startRow);
        element.style.setProperty('grid-row-end', startRow + 1);

        this.updateColSplitters(element, oldStartRow);

        const details = {
          direction: 'row',
          oldStartRow: Number(oldStartRow / 2),
          startRow: Number(startRow / 2),
          startCol: Math.ceil(Number(element.style['grid-column-start'] / 2)),
          endCol: Number(element.style['grid-column-end'] / 2) + 1,
        };

        element.dispatchEvent(
          new CustomEvent('splitter-event', { bubbles: true, detail: details })
        ); //
      }

      if (element.id.includes('col')) {
        const min = Number(element.attributes['min-grid'].value);
        const max = Number(element.attributes['max-grid'].value);

        if (startCol <= min) startCol = min + 1;
        if (startCol + 1 > max) startCol = max - 1;

        const oldStartCol = element.style['grid-column-end'];

        startCol =
          Math.abs(startCol - element.style['grid-column-start']) % 2 == 0
            ? startCol
            : startCol - 1;
        element.style.setProperty('grid-column-start', startCol);
        element.style.setProperty('grid-column-end', startCol + 1);

        this.updateRowSplitters(element, oldStartCol);

        const details = {
          direction: 'col',
          oldStartCol: Math.ceil(Number(oldStartCol) / 2),
          startCol: Number(startCol / 2) + 1,
          startRow: Math.ceil(Number(element.style['grid-row-start'] / 2)),
          endRow: Number(element.style['grid-row-end'] / 2) + 1,
        };

        element.dispatchEvent(
          new CustomEvent('splitter-event', { bubbles: true, detail: details })
        ); //
      }
    }
  }

  updateColSplitters(movedSplitter, oldStartRow) {
    const children = movedSplitter.parentElement.children;
    const splitterColStart = Number(movedSplitter.style['grid-column-start']);
    const splitterColEnd = Number(movedSplitter.style['grid-column-end']);
    const splitterRowStart = Number(movedSplitter.style['grid-row-start']);
    const splitterRowEnd = Number(movedSplitter.style['grid-row-end']);
    for (let i = 0; i < children.length; i++) {
      const childColStart = Number(children[i].style['grid-column-start']);
      const childColEnd = Number(children[i].style['grid-column-end']);
      const childRowStart = Number(children[i].style['grid-row-start']);
      const childRowEnd = Number(children[i].style['grid-row-end']);
      if (childColStart > splitterColStart && childColEnd < splitterColEnd) {
        if (childRowEnd == Number(oldStartRow)) {
          if (childRowEnd != splitterRowStart) {
            children[i].style.setProperty('grid-row-end', splitterRowStart);
          }
        }
        if (childRowStart == Number(oldStartRow) + 1) {
          if (childRowStart != splitterRowEnd) {
            children[i].style.setProperty('grid-row-start', splitterRowEnd);
          }
        }
      }
    }
  }

  updateRowSplitters(movedSplitter, oldStartCol) {
    const children = movedSplitter.parentElement.children;
    const splitterColStart = Number(movedSplitter.style['grid-column-start']);
    const splitterColEnd = Number(movedSplitter.style['grid-column-end']);
    const splitterRowStart = Number(movedSplitter.style['grid-row-start']);
    const splitterRowEnd = Number(movedSplitter.style['grid-row-end']);
    for (let i = 0; i < children.length; i++) {
      const childColStart = Number(children[i].style['grid-column-start']);
      const childColEnd = Number(children[i].style['grid-column-end']);
      const childRowStart = Number(children[i].style['grid-row-start']);
      const childRowEnd = Number(children[i].style['grid-row-end']);
      if (childRowStart > splitterRowStart && childRowEnd < splitterRowEnd) {
        if (childColEnd == Number(oldStartCol) - 1) {
          if (childColEnd != splitterColStart)
            children[i].style.setProperty('grid-column-end', splitterColStart);
        }
        if (childColStart == Number(oldStartCol)) {
          children[i].style.setProperty('grid-column-start', splitterColEnd);
        }
      }
    }
  }
}
